import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertModalComponent } from 'src/app/shared/components/alert-modal/alert-modal.component';
import { MenuFunctionalityEnum } from 'src/app/shared/components/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/components/menu/menu.module.enum';
import { ReportModalComponent } from 'src/app/shared/components/report-modal/report-modal.component';
import { VerifyDate } from 'src/app/shared/custom-validators/date-age.validator';
import { GrievanceNotificationStatusEnum } from 'src/app/shared/enum/hospital-document/grievance-notification-status.enum';
import { GrievanceNotificationEnum } from 'src/app/shared/enum/hospital-document/grievance-notification.enum.ts';
import { TypeFieldGrievanceNotificationEnum } from 'src/app/shared/enum/hospital-document/type_field-grievance-notification.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { GuideGrievanceNotificationService } from 'src/app/shared/services/API/orchestrator-patient/guide-grievance-notification.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { LookupValueGrievanceNotification } from 'src/app/shared/services/models/hospital-document/lookup-value-grievance-notification.model';
import { CreateUpdateGuideGrievanceNotificationRequest } from 'src/app/shared/services/requests/hospital-document/create-update-guide-grievance-notification.request';
import { GetGuideGrievanceNotificationToRegisterPageResponse } from 'src/app/shared/services/responses/hospital-document/get-guide-grievance-notification-to-register-page.response';
import { GuideGrievanceNotificationReportResponse } from 'src/app/shared/services/responses/hospital-document/guide-grievance-notification-report.response';
import { FieldGuideStruct } from 'src/app/shared/services/structs/hospital-document/field-guide.struct';
import { FieldsGrievanceNotificationStruct } from 'src/app/shared/services/structs/hospital-document/fields-grievance-notification.struct';
import { SectionGrievanceNotificationStruct } from 'src/app/shared/services/structs/hospital-document/section-grievance-notification.struct';

@Component({
    selector: 'app-fill-grievance-notification',
    templateUrl: './fill-grievance-notification.component.html',
    styleUrls: ['./fill-grievance-notification.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FillGrievanceNotificationComponent implements OnInit {
  
  @Input() menuModuleEnum: MenuModuleEnum;
  @Input() menuFunctionalityEnum: MenuModuleEnum;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private guideGrievanceNotificationService: GuideGrievanceNotificationService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private maskService: MaskService,
    private router: Router
  ) { }

  // public menuModuleEnum: MenuModuleEnum = MenuModuleEnum.classification;
  // public menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.classification_grievance_notification_pending;
  public typeFieldGrievanceNotificationEnum: typeof TypeFieldGrievanceNotificationEnum = TypeFieldGrievanceNotificationEnum;
  public grievanceNotificationEnum: typeof GrievanceNotificationEnum = GrievanceNotificationEnum;
  public grievanceNotificationStatusEnum: typeof GrievanceNotificationStatusEnum = GrievanceNotificationStatusEnum;

  public model: FormGroup;
  public masks: Masks = this.maskService.getMasks();

  public listFiltered: any[] = [];
  public listFieldsGrievanceNotification: FieldsGrievanceNotificationStruct[] = [];
  public listSectionGrievanceNotificationStruct: SectionGrievanceNotificationStruct[] = [];
  public listLookupValueGrievanceNotification: LookupValueGrievanceNotification[] = [];//Valores para serem mostrados no select

  public idGrievanceNotification: number;
  public idSector: number;
  public idRoom: number;
  public idGuideGrievanceNotification: number;
  public idEpisode: number;
  
  public grievanceNotificationName: string;

  public isLoading: boolean = true;
  public isFirstLoading: boolean = true;
  public readOnly: boolean = false;
  public isCompletedPage: boolean = false;

  ngOnInit(): void {
    
    if(this.activatedRoute.snapshot.paramMap.get('idGrievanceNotification'))
      this.idGrievanceNotification = parseInt(this.activatedRoute.snapshot.paramMap.get('idGrievanceNotification'));

    if(this.activatedRoute.snapshot.paramMap.get('idGuideGrievanceNotification'))
      this.idGuideGrievanceNotification = parseInt(this.activatedRoute.snapshot.paramMap.get('idGuideGrievanceNotification'));

    if(this.activatedRoute.snapshot.paramMap.get('idSector'))
      this.idSector = parseInt(this.activatedRoute.snapshot.paramMap.get('idSector'));

    if(this.activatedRoute.snapshot.paramMap.get('idRoom'))
      this.idRoom = parseInt(this.activatedRoute.snapshot.paramMap.get('idRoom'));

    if(this.activatedRoute.snapshot.paramMap.get('idEpisode'))
      this.idEpisode = parseInt(this.activatedRoute.snapshot.paramMap.get('idEpisode'));

    if (this.activatedRoute.snapshot.paramMap.get('readOnly'))
      this.readOnly = this.activatedRoute.snapshot.paramMap.get('readOnly') === "true";

    if (this.activatedRoute.snapshot.paramMap.get('completPage'))
      this.isCompletedPage = this.activatedRoute.snapshot.paramMap.get('completPage') === "true";

    this.model = this.formBuilder.group({
      guideNumber: [{value: '', disabled: this.readOnly}, [Validators.required]],
      listFields: this.formBuilder.array([]),
    });

    if (this.idGuideGrievanceNotification) 
      this.getGrievanceNotificationDetails();
  }

  submit(status?): void {

    if(this.isLoading)
      return;

    this.model.markAllAsTouched();
    if (this.model.invalid || !this.model.get('listFields') 
      || !this.model.get('listFields').value || !(this.model.get('listFields').value.length > 0)) {
      this.alertService.show('Erro', 'Verifique/preencha todos os campos em vermelho.', AlertType.error);
      return;
    }
    
    this.isLoading = true;
    let request: CreateUpdateGuideGrievanceNotificationRequest = this.mapRequest();
    request.idGrievanceNotificationStatus = status ? status : this.grievanceNotificationStatusEnum.pendente;
    request.idModule = this.menuModuleEnum;

    this.guideGrievanceNotificationService.updateGuideGrievanceNotification(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }
        this.alertService.show('Sucesso!', 'Dados configurados com sucesso', AlertType.success);
        
        if(response.reportPdf64)
          this.openReportModal(response);
        else
          this.goBack();

        this.isLoading = false;
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
        return;
      }
    });
  }

  mapRequest(): CreateUpdateGuideGrievanceNotificationRequest{
    let request: CreateUpdateGuideGrievanceNotificationRequest = new CreateUpdateGuideGrievanceNotificationRequest();
    request.idGuideGrievanceNotification = this.idGuideGrievanceNotification;
    request.idEpisode = this.idEpisode;
    request.idGrievanceNotification = this.idGrievanceNotification;
    request.numberOfGuide = this.model.get('guideNumber').value;

    this.listSectionGrievanceNotificationStruct.forEach(section => {
      section.listFieldsGrievanceNotificationStruct.forEach((field) => {
        
        let item: FieldGuideStruct = new FieldGuideStruct();
        item.nameVariableGrievanceNotification = field.nameVariableGrievanceNotification;
        let formControlValue = this.model.get('listFields')['controls'][field.indexFormArray].get(field.nameVariableGrievanceNotification).value;
        
        if(field.idTypeFieldGrievanceNotification === this.typeFieldGrievanceNotificationEnum.select && formControlValue) {
          item.fieldValue = formControlValue.idLookupValueGrievanceNotification.toString();
        } else if (field.idTypeFieldGrievanceNotification === this.typeFieldGrievanceNotificationEnum.multiselect && formControlValue) {
          const selectedOptions = formControlValue as LookupValueGrievanceNotification[];
          item.fieldValue = selectedOptions.map(val => val.idLookupValueGrievanceNotification).join(',');
        } else {
          item.fieldValue = formControlValue?.toString();
        }

        item.complementFieldValue = this.model.get('listFields')['controls'][field.indexFormArray].get('complement')?.value;
        item.idFieldGrievanceNotification = field.idFieldGrievanceNotification;

        request.listFieldGuideStruct.push(item);
      })
    });

    return request;
  }

  openReportModal(response: GuideGrievanceNotificationReportResponse) {
    let reportDialog = this.dialog.open(ReportModalComponent, {
      data: {
        reportName: response.reportName,
        reportPdf64: response.reportPdf64,
      },
    });
    reportDialog.afterClosed().subscribe({
      next: result => {
        this.goBack();
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  finalizeFormFilling(status) {
    if(this.isLoading)
      return;

    this.model.markAllAsTouched();
    if (this.model.invalid || !this.model.get('listFields') 
      || !this.model.get('listFields').value || !(this.model.get('listFields').value.length > 0)) {
      this.alertService.show('Erro', 'Verifique/preencha todos os campos em vermelho.', AlertType.error);
      return;
    }

    const dialogRef = this.dialog.open(AlertModalComponent, {
      data: {
        isTwoButtonsModal: true,
        title: 'Atenção!',
        description: `Realmente deseja concluir o preenchimento dessa notificação?`,
        hasImage: true,
        textButtonConfirm: "Sim",
        textButtonCancel: "Não"
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result && result.confirm)
          this.submit(status);
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);      }
    });
  }

  cancel() {
    if(this.isCompletedPage){
      this.goBack();
      return;
    }
    const dialogRef = this.dialog.open(AlertModalComponent, {
      data: {
        isTwoButtonsModal: true,
        title: 'Atenção!',
        description: `Existem alterações não salvas. Deseja prosseguir?`,
        hasImage: true,
        textButtonConfirm: "Sim, prosseguir sem salvar",
        textButtonCancel: "Não, voltar e salvar"
      },
    });
    dialogRef.afterClosed().subscribe({
      next: (result) => {
        if (result && result.confirm)
          this.goBack();
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);      }
    });
  }

  goBack() {
    if(this.menuModuleEnum == MenuModuleEnum.classification) {
      if(this.idRoom && this.idSector)
        this.router.navigate(['/classification/classification-patient-list', { idRoom: this.idRoom, idSector: this.idSector }]);
      else if (this.isCompletedPage)
        this.router.navigate(['/classification/grievance-notification/completed']);
      else
        this.router.navigate(['/classification/grievance-notification/pending']);
    } else if (this.menuModuleEnum == MenuModuleEnum.basic_care){
      if(this.idRoom && this.idSector)
        this.router.navigate(['/basic-care/patient-list', { idRoom: this.idRoom, idSector: this.idSector }]);
      else if (this.isCompletedPage)
        this.router.navigate(['/basic-care/grievance-notification/completed']);
      else
        this.router.navigate(['/basic-care/grievance-notification/pending']);
    }
    
  }

  getGrievanceNotificationDetails(): void {
    this.guideGrievanceNotificationService.getGrievanceNotificationToRegister(this.idGuideGrievanceNotification, this.idEpisode, this.menuModuleEnum).subscribe({
      next: (response: GetGuideGrievanceNotificationToRegisterPageResponse) => {
        if (response.isError) {
          if (response.errorCode == 1) {
            this.openAlertModalToDisplayInvalidPermissionToEdit();
            return;
          }
          else {
            this.alertService.show('Erro', response.errorDescription, AlertType.error);
            this.isLoading = false;
            return;
          }          
        }
        console.log("response: ", response);
       
        this.listLookupValueGrievanceNotification = response.listLookupValueGrievanceNotification;
        this.listSectionGrievanceNotificationStruct = response.guideValuesAndCompletedConfig?.listSectionGrievanceNotificationStruct;
        this.grievanceNotificationName = response.guideValuesAndCompletedConfig?.grievanceNotificationName;
        this.idGrievanceNotification = response.guideValuesAndCompletedConfig?.idGrievanceNotification;
        this.model.get('guideNumber').setValue(response.guideValuesAndCompletedConfig?.numberOfGuide);
        this.createFormControls();
        
      },
      error: (error) => {
        this.alertService.show('Erro', 'Falha ao carregar os detalhes.', AlertType.error);
        this.isLoading = false;
      }
    });
  }

  openAlertModalToDisplayInvalidPermissionToEdit() {
    const dialogRef = this.dialog.open(AlertModalComponent, {
      data: {
        isTwoButtonsModal: false,
        title: 'Aviso',
        description: 'Você não tem permissão para editar esta notificação. Certifique-se de ter triado a este episódio ou solicite permissão de edição ao responsável.'
      },
    });
    dialogRef.afterClosed().subscribe({
      next: result => {
        this.isLoading = false;
        this. goBack();
      }
    });

    return;
  }

  createFormControls(): void {

    let index: number = 0;
    this.listSectionGrievanceNotificationStruct.forEach(section => {
      section.listFieldsGrievanceNotificationStruct.forEach((field) => {
          let formGroup = this.formBuilder.group({});
          let validators = field.isRequired ? [Validators.required] : [];

          let fieldValue = null;
          if(field.idTypeFieldGrievanceNotification === this.typeFieldGrievanceNotificationEnum.select && field.fieldValue) {
            fieldValue = this.listLookupValueGrievanceNotification.find(x => x.idLookupValueGrievanceNotification == parseInt(field.fieldValue))
          } 
          else if (field.idTypeFieldGrievanceNotification === this.typeFieldGrievanceNotificationEnum.multiselect && field.fieldValue) {
            const selectedIds = field.fieldValue.split(',').map(id => parseInt(id.trim()));
            fieldValue = this.listLookupValueGrievanceNotification.filter(x => selectedIds.includes(x.idLookupValueGrievanceNotification));
          }
          else {
            fieldValue = field.fieldValue;
          }

          let requiresComplement = false;
          if (field.hasComplementField) {
            requiresComplement = true;
          } else if (fieldValue) {
            if (Array.isArray(fieldValue)) {
              requiresComplement = fieldValue.some(val => val.hasComplementField);
            } else {
              requiresComplement = fieldValue.hasComplementField;
            }
          }

          formGroup.addControl(
            field.nameVariableGrievanceNotification, 
            this.formBuilder.control({ value: fieldValue, disabled: (this.readOnly || field.isDisableFieldFill) }, validators)
          );

          if(field.hasComplementField || (field.idTypeFieldGrievanceNotification === this.typeFieldGrievanceNotificationEnum.select && fieldValue?.hasComplementField))
            formGroup.addControl('complement', this.formBuilder.control({value: field.complementFieldValue, disabled: this.readOnly}));

          (this.model.controls['listFields'] as FormArray).push(formGroup);
          field.indexFormArray = index;
          index++;
      })
    })
    this.isLoading = false;
    this.isFirstLoading = false;
  }

  addComplement(field: FieldsGrievanceNotificationStruct, lookupValue: LookupValueGrievanceNotification, indexFormArray: boolean) {
    if(field.hasComplementField)
      return;

    if(lookupValue.hasComplementField) {
      this.model.get('listFields')['controls'][indexFormArray].addControl('complement', this.formBuilder.control({value: '', disabled: this.readOnly}))
    }
    else {
      const formGroup = this.model.get('listFields')['controls'][indexFormArray] as FormGroup;
      
      if (formGroup.contains("complement")) 
        formGroup.removeControl("complement");
    }

  }

  removeDuplicates(array: any[], key: string): any[] {
    const unique = array
      .map((e) => e[key])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter((e) => array[e])
      .map((e) => array[e]);
    return unique;
  }

  verifyDate(controlId: number, indexFormArray): void {
    const control = this.model.get('listFields')['controls'][indexFormArray].get(controlId.toString());
    const validationError = VerifyDate()(control);

    if (validationError)
      control.setErrors({ ...control.errors, ...validationError });
    else
      control.setErrors(null);
  }

  filterLookup(idLookup: number): LookupValueGrievanceNotification[] {
    return this.listLookupValueGrievanceNotification.filter(x => x.idLookupTypeGrievanceNotification = idLookup)
  }

  openPdfInstructions() {
    switch (this.idGrievanceNotification) {
      case this.grievanceNotificationEnum.AcidentesPorAnimaisPeconhentos:
        window.open('assets/pdf/grievance-notification/animais_peconhentos_v5_instr.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.AtendimentoAntiRabicoHumano:
        window.open('assets/pdf/grievance-notification/anti_rabico_v5_instr.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.ViolenciaInterpessoalAutoprovocada:
        window.open('assets/pdf/grievance-notification/violencia.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.DengueEFebreDeChikungunya:
        window.open('assets/pdf/grievance-notification/instrucional_dengue_chikungunya.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.Influenza:
        window.open('assets/pdf/grievance-notification/instrucional_influenza.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.IntoxicacaoExogena:
        window.open('assets/pdf/grievance-notification/Intoxicacao_Exogena_v5_instr.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.AcidenteDeTrabalho:
        window.open('assets/pdf/grievance-notification/instrucional_acidente_trabalho_grave.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.AcidenteDeTrabalhoComExposicaoAMeterialBiologico:
        window.open('assets/pdf/grievance-notification/instrucional_acidente_trabalho_biologico_v5.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.Tuberculose:
        window.open('assets/pdf/grievance-notification/instrutivo_preenchimento_tuberculoso.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.SifilisCongenita:
        window.open('assets/pdf/grievance-notification/sifilis_congenita_v5_instr.pdf', '_blank');
        break;
      case this.grievanceNotificationEnum.Meningite:
        window.open('assets/pdf/grievance-notification/meningite_v5_instr.pdf', '_blank');
        break;
    }
  }

  addComplementMultiselect(field: FieldsGrievanceNotificationStruct, selectedValues: LookupValueGrievanceNotification[], indexFormArray: number) {
  if (field.hasComplementField) return;

  const formGroup = this.model.get('listFields')['controls'][indexFormArray] as FormGroup;
  
  const requiresComplement = selectedValues && selectedValues.some(val => val.hasComplementField);

  if (requiresComplement && !formGroup.contains('complement')) {
    formGroup.addControl('complement', this.formBuilder.control({value: '', disabled: this.readOnly}));
  } 
  else if (!requiresComplement && formGroup.contains('complement')) {
    formGroup.removeControl('complement');
  }
}

}